import ReactGA from 'react-ga'

export default function() {
  ReactGA.initialize('UA-109299047-1')
  return store => next => action => {
    if (action.type.indexOf('LOCATION_') === 0 ){
      try {
        ReactGA.pageview(action.meta.location.current.pathname)
        // console.log('SEND NAV ANALYTIC', action.meta.location.current.pathname)
      } catch (e) {}
    }
    return next(action)
  }
}



// WEBPACK FOOTER //
// ./src/redux/middleware/analytics.js